// project import
import stations from './stations';
import admin from './admin';
import account from './account';

// ==============================|| MENU ITEMS ||============================== //

const menuItems = {
    accountItems: [account],
    items: [stations, admin]
};

export default menuItems;
